import './App.css';

const particles = Array.from({ length: 22 }, (_, i) => ({
  left: (i * 17 + 9) % 100,
  size: 2 + (i % 4),
  duration: 7 + (i % 6),
  delay: (i % 9) * 0.7,
}));

const hearts = Array.from({ length: 10 }, (_, i) => ({
  left: (i * 11 + 4) % 100,
  duration: 11 + (i % 5) * 1.6,
  delay: (i % 6) * 1.1,
  symbol: i % 3 === 0 ? '❥' : i % 2 === 0 ? '♡' : '❤',
}));

function App() {
  return (
    <main className="love-page">
      <div
        className="bg-photo"
        style={{
          backgroundImage:
            "linear-gradient(125deg, rgba(13, 7, 17, 0.18), rgba(62, 15, 42, 0.14)), url(" +
            process.env.PUBLIC_URL +
            '/couple.jpeg)',
        }}
        role="img"
        aria-label="Anupam and Aparna"
      />

      <div className="top-vignette" aria-hidden="true" />
      <div className="glow glow-left" aria-hidden="true" />
      <div className="glow glow-right" aria-hidden="true" />

      <div className="particle-layer" aria-hidden="true">
        {particles.map((dot, index) => (
          <span
            key={`p-${index}`}
            className="particle"
            style={{
              '--x': `${dot.left}%`,
              '--size': `${dot.size}px`,
              '--duration': `${dot.duration}s`,
              '--delay': `${dot.delay}s`,
            }}
          />
        ))}
      </div>

      <div className="floating-hearts" aria-hidden="true">
        {hearts.map((heart, index) => (
          <span
            key={`h-${index}`}
            style={{
              '--left': `${heart.left}%`,
              '--duration': `${heart.duration}s`,
              '--delay': `${heart.delay}s`,
            }}
          >
            {heart.symbol}
          </span>
        ))}
      </div>

      <section className="love-card">
        <div className="love-badge">❤</div>
        <p className="tag">অনুপম ❤ অপর্ণা</p>
        <h1>তোমার সাথে প্রতিটা মুহূর্ত আমার জীবনের সবচেয়ে সুন্দর গল্প</h1>
        <p className="message">
          অপর্ণা, তুমি আমার শান্তি, আমার হাসি, আর আমার প্রতিটা স্বপ্নের সবচেয়ে প্রিয় অংশ।
          তোমার হাতটা ধরে এই পথটুকু সারাজীবন হাঁটতে চাই।
        </p>

        <div className="promise-row">
          <span>সবসময় পাশে</span>
          <span>অফুরন্ত ভালোবাসা</span>
          <span>চিরদিন আমরা</span>
        </div>

        <p className="signature">অনেক অনেক ভালোবাসা, তোমার অনুপম</p>
      </section>
    </main>
  );
}

export default App;
